export default __webpack_public_path__ + "static/handBlue-4500ce51f9f01a544dd97a19745c54ca.png";